:host {
  display: block;
  padding: 4.375rem 1rem;
  font-family: var(--cwc-font-sans-serif-regular, 'Eina01-Regular');
  font-weight: 500;
  margin-left: auto;
  margin-right: auto;
}

@media (min-width:768px) {
  :host {
    padding: 4.375rem 3.25rem;
  }
}

@media (min-width:1024px) {
  :host {
    padding: 4.6875rem 3.5rem;
  }
}

.left:first-child {
  margin-top: auto;
}
